$(document).ready(function(){
	
    $('.swatch-element').on('click',function(){
  		var getInputValue = $(this).find('input').val();
  		
        var getVariantId = $("#variant-selector option[data-variant-title='"+getInputValue+"']").attr('value');
  		
      	$("#variant-selector").val(getVariantId);
      	$('[name="id"]').val(getVariantId);
      	$("#variant-selector option").removeAttr('selected');
      	$("#variant-selector option[data-variant-title='"+getInputValue+"']").attr('selected','selected');
      	$('.swatch-element').removeClass('is-selected-swatch');
      	$(this).addClass('is-selected-swatch');
  		variantURLUpdate(getVariantId);
      	var getVariantFeaturedImage = $(this).attr('data-swatch-variant');
        showImageSlider(getVariantFeaturedImage);
	});
  $(".product-form").off('submit');
  $(".product-form").submit(function(event){
  	event.preventDefault();
    var quantityVal = $(this).find('[name="quantity"]').val();
    var idVal = $('[name="id"]').val();
    setTimeout(function(){
      $('.quick-cart__items').empty();
    },1000);
    var myTimeout = setTimeout(function(){
    	addProductToCart(quantityVal,idVal);
      	clearTimeout(myTimeout);
    },1200);
    
  })
  $('.swatch-element.available').eq(0).trigger('click');
  
  $('.js-cart-count').on('click', function() {
    fetchCart();
  });
  
  $(document).on('click', 'a.exit-intent__close', function() {
$('#shopify-section-exit-intent').hide();
  });
  $('.drawer-overlay, .quick-cart__close').on('click', function() {
    closeCartDrawer();
  });
  
  $('.quick-cart__indicator-inner').on('click', function() {
  	openCartDrawer();
  })
  
})


function showImageSlider(getVariantFeaturedImage) {
  
	var getJsonObj = JSON.parse($('.imagesDiv').html());
  	var imageDiv = {};
    $.each(getJsonObj, function(i,v) {
      	var splitedVal = 'yes-'+(getJsonObj[i].alt);
      	if(getJsonObj[i].alt != null && (getJsonObj[i].alt).indexOf(" ") > 0) splitedVal = 'yes-'+((getJsonObj[i].alt).split(' ').join('-'));
      	if(imageDiv[splitedVal] == undefined ) imageDiv[splitedVal] = [];
      	imageDiv[splitedVal].push(getJsonObj[i])
    });
    if(imageDiv[getVariantFeaturedImage]) {
      var imageElements = "";
      $.each(imageDiv[getVariantFeaturedImage], function(i,v) {
          var splitedVal = 'yes-'+((imageDiv[getVariantFeaturedImage][i].alt).split(' ').join('-'));
          imageElements = imageElements + `
  <div id="data-media-${imageDiv[getVariantFeaturedImage][i].alt}" data-media-id="${imageDiv[getVariantFeaturedImage][i].id}" class="${splitedVal}">
        <img class="mySlides" src="${imageDiv[getVariantFeaturedImage][i].src}" style="width:100%">
     </div> `;
      })
      $('.product__media').empty().append('<div class="slider-for ${getVariantFeaturedImage}">'+imageElements+'</div>');
      $('.slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false
      });
    }
    /*$('.product__media .product-slider-images').each(function(i,v){
    if($(v).attr('data-image') == getVariantFeaturedImage && firstIteration == 0) {
  		var getSlickIndex = $(v).attr('data-slick-index');
        if(getSlickIndex >= 0 ) {
          console.log(getSlickIndex)
          firstIteration = 1;
          $('.slider-for').slick('slickGoTo', getSlickIndex);
        }
      	//console.log(getSlickIndex);
    }
  })*/
}

  
function variantURLUpdate(variantId) {

  var newurl =
      window.location.protocol +
      '//' +
      window.location.host +
      window.location.pathname +
      '?variant=' +
      variantId;
  window.history.replaceState({ path: newurl }, '', newurl); 
}


function fetchCart() {
 	fetch('/cart.js', {credentials: 'same-origin'})
    .then(function(r) {
      return r.json();
    })
    .then(function(cart) {
      renderCart(cart);
    }); 
}

function addProductToCart(getQuantity, getId) {
  let formData = {
   'items': [{
    'id': getId,
    'quantity': getQuantity
    }]
  };
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    fetchCart();
    openCartDrawer();
    
    return response.json();
  })
  .catch((error) => {
    //console.error('Error:', error);
  });

}

function addToCartOk(product) {        
  fetchCart();
  openCartDrawer();
}

function addToCartFail() {
  fetchCart();
}



function renderCart(cart) {
	var cartItemhtml = "";
	cart.items.forEach(function(item) {
      console.log(item);
      	var getPrice = "$" + ((item.price/100).toFixed(2).toLocaleString());
		cartItemhtml = cartItemhtml + `<div class="cart__item dial-item-${item.product_title}" data-component="quickCartItem" data-id="${item.id}">
		  <div class="cart__item-content">
			<div class="quick-cart__image">
			
				  <a href="${item.url}">
					<img src="${item.image}">
				  </a>
				
			</div>
			<div class="quick-cart__product-details justify-between">
			  <div>
				<h4 class="ma0">
				  <a href="${item.url}">${item.product_title}</a>
				</h4>
				<span class="quick-cart__product-price">
				  <span class="quick-cart__product-price-value">
					${getPrice} <span></span>
				  </span>
		  
				</span>	
		  
			  </div>
			</div>
		  </div>

		  <div class="quick-cart__item-bottom">
			<div class="quick-cart__quantity">
			  <button type="button" class="quick-cart__quantity-button js-remove-single px05"><svg width="10" height="2" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1h8" stroke="currentColor" stroke-linecap="square"></path></svg></button>
			  <div class="quick-cart__item-total js-single-quantity">${item.quantity}</div>
			  <button type="button" class="quick-cart__quantity-button js-add-single px05"><svg width="11" height="11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.5 0v11M0 5.5h11" stroke="currentColor"></path></svg></button>
			</div>
		  </div>
		</div>`;
	});

	$('.quick-cart__items').empty().append(cartItemhtml);
  	$('.quick-cart__indicator-inner').html(cart.item_count);
  	quantityIncreaseDecrease();
  	var total_price = "$"+(parseInt(cart.total_price)/100).toFixed(2).toLocaleString(); 
  	$('.js-subtotal').html(total_price)
  	$('.js-footer').removeClass('active');
    if (cart.item_count > 0) {
		$('.js-footer').addClass('active');
    }

}

function quantityIncreaseDecrease() {
	$(".js-add-single").off('click').on("click", function(){
      let vId = $(this).closest('.cart__item').attr("data-id");
      let ajaxcart__qty = $(this).siblings('.quick-cart__item-total').html();
      
      ajaxcart__qty = parseInt(ajaxcart__qty)+parseInt(1);
      $(this).siblings('.quick-cart__item-total').html(ajaxcart__qty);
      var updateData = {
              quantity: ajaxcart__qty,
              id: vId
      }
     	   $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                dataType: 'json',
                data: updateData,
                success: function(cart){
                   //cartCounter.innerHTML = Number(cartCounter.innerHTML) + 1;        
        		   fetchCart();
                },
                error: addToCartFail
            });
		return false;
    });
    $(".js-remove-single").off('click').on("click", function(){
      let vId = $(this).closest('.cart__item').attr("data-id");
      let ajaxcart__qty = $(this).siblings('.quick-cart__item-total').html();
	  
      ajaxcart__qty = parseInt(ajaxcart__qty)-parseInt(1);
      if(ajaxcart__qty>=1){
        $(this).siblings('.quick-cart__item-total').html(ajaxcart__qty);
          var updateData = {
             quantity: ajaxcart__qty,
             id: vId
          }
      }else{
        $(this).closest('.js-single-quantity').html(0);
        var updateData = {
             quantity: 0,
             id: vId
          }
      }
      	   $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                dataType: 'json',
                data: updateData,
                 success: function(cart){
                   //cartCounter.innerHTML = Number(cartCounter.innerHTML) - 1;        
        		   fetchCart();
                 },
                error: addToCartFail
            });
		return false;
    });
}

function openCartDrawer() {
	$('.cart-flyout').addClass('is-visible');
	$('.cart-flyout').addClass('is-active');
	$('.drawer-overlay').addClass('is-active');
	$('.drawer-overlay__inner').addClass('is-visible');
}

function closeCartDrawer() {
	$('.drawer.cart-flyout').removeClass('is-visible');
	$('.drawer.cart-flyout').removeClass('is-active');
	$('.drawer-overlay').removeClass('is-active');
	$('.drawer-overlay__inner').removeClass('is-visible');
}